/**
 * Canonical support contact.
 * Use this everywhere the user needs to reach us — never hardcode an address.
 */
export const SUPPORT_EMAIL = "support@authoritylayer.app";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const SUPPORT_RESPONSE_SLA = "We typically respond within 24 hours.";
